module.exports = __webpack_public_path__ + "img/Cost.e7ccebab.svg";